export { DMS_MODULE } from '../constants';
export const CRUMB_LABEL_KEY = 'edtFakturace';
export const NAME = 'Fakturace';
export const PRIMARY_CUSTOMER_SPLIT_INDEX = 0;
export const MENU_CODE = 'Zakazka';
export const BILLING_OPERATION_CODE ='OP_BILLING';
// TODO: pouvazovat nad lepsim umiestnenim
export enum DruhyDoklNv {
	DNV_TISK = 'S',
	DNV_PROFORMA = 'U',
	DNV_DOBROPIS = 'T',
	DNV_STORNO_FA = 'K',
	DNV_INTERNI_FA = 'F',
	DNV_PROFORMA_INTERNI = 'FU',
	DNV_ZALOHA_FA = 'L',
	DNV_ZALOHA_STORNO = 'LS',
	DNV_ZALOHA_PENALE = 'LP',
	DNV_1DD = 'ZN',
	DNV_1DD_DOBROPIS = 'ZR',
	DNV_1DD_STORNO = 'ZP',
	DNV_CAST_DOBROPIS = 'TC',
	DNV_VRUBOPIS = 'TP',
	DNV_STORNO_FA_ID = 'KI',
	DNV_UNDEFINED = '',
}

// TODO: pouvazovat nad lepsim umiestnenim
export enum PlatbaTyp {
	NET_BANKING = 0,
	CASH = 1,
	CREDIT_CARD = 2,
	POSTAL_CARD = 3,
	INTERNAL = 99,
	FOREIGN_CURRENCY = 4,
	DONT_PAY = 98,
	NEFT = 100,
	DEBIT_CARD = 101,
	UPI = 103,
	MOBILE_WALLET = 102,
	CHEQUE = 104
}
export enum ApproverStatus {
	APPROVE = 1,
	SUBMITTED = 2,
	REJECT = 3
}
export enum DokladNaplnFakturaci {
	PRVNI_DD = 1,
	DRUHY_DD = 2,
	ZKRACENY_DD = 3,
	ZALOHA = 4,
	VRUBOPIS = 5,
	CASTECNY_DOBROPIS = 6,
	DOBROPIS = 7,
	STORNO = 9,
	PRO_FORMA = 10,
	NABIDKA = 11,
	KOPIE = 12,
	OPRAVA = 13,
	POLOZKOVY_DOBROPIS = 14,
	QUICK_ESTIMATE = 21,
	SALE_QUOTE = 22,
	REF_DOC = 20,
}

export enum TypPrijemceFaktury {
	ZAKAZNIK = 1,
	SIDLO = 2,
	JINY_PRIJEMCE = 3,
	LEASING = 4,
	POISTOVNA = 5,
	DEALERSHIP = 6
}

export enum OrderSubType {
	BODY_SHOP = 3,
	PDI = 4,
	PDI_V = 59,
}

export enum REPORT_TYPE {
	CUSTOMER_SATISFACTION = 'CS',
	WARRANTY_INVOICE = 'WI',
	DETAILED_ESTIMATE = 'DE',
	QUICK_ESTIMATE = 'QE',
	SALES_QUOTE = 'SQ',
	PERFORMA = 'X'
}

export interface IPartialInvoice {
	CustomerId?: number;
	CustomerName: string;
	SplitPartyTypeId: number;
	SplitPartyTypeName: string;
	IsBilled: boolean;
	BillingDate?: Date;
	IsSelected: boolean;
	OverAllLineItemCompletionStatus: boolean;
	IsCreditNote: boolean;
	CreditNoteDate: Date;
	IsNewLineItemAfterBillingAndCreditNote: boolean;
	ShareAmount: number;
	CashAmount: 0;
	CreditAmount: 0;
	DebitAmount: 0;
	OnlineAmount: 0;
	AdvanceTotalPayment: 0;
	ActualTotalPayment: 0;
	IsPartsAvailable: false;
	IsLOAvailable: false;
	PartTotal : 0,
	LaborTotal : 0
}

export enum EGUI_OPTIONS {
	EGUI_ISSUE = 'issueInvoice',
	EGUI_PRINT = 'printInvoice',
	EGUI_CANCEL = 'cancelInvoice',
	EGUI_RTN_CODE = 7,
	EGUI_ADVANCE_AMOUNT_MORE = '[SalesAmount]',
	IS_ITEM_SEPRATED = '1',
	IS_ITEM_NOT_SEPRATED = '0',
	EGUI_SUCCESS= '開立發票成功',
}

export enum EGUI_TRANS_OPTIONS {
	SEPERATE = 1,
	COMBINE = 2
}
export enum EGUI_TYPES {
	COMPANY = 1,
	WITH_CARRIER = 2,
	NO_CARRIER = 3
}
export enum EGUI_PAYMENT_VALIDATION {
	CASH = 1,
	CREDIT_CARD = 2,
	DEBIT_CARD = 3,
	ONLINE = 4
}
export interface IeGUISplitOptions {
	eGUISplitPartyTypeId: number;
	eGUISplitPartyTypeName: string;
	SharePercentage: 0;
	PartsAmount: 0;
	LaborAmount: 0;
	CashAmount: 0;
	CreditAmount: 0;
	DebitAmount: 0;
	OnlineAmount: 0;
	AdvanceTotalPayment: 0;
	ActualTotalPayment: 0;
	ActualShareTotalPayment: 0;
	IsPartsAvailable: false;
	IsLOAvailable: false;
}
